import { usePmsInfo } from './usePmsInfo'

/**
 * Where the browser's MEWS-shaped calls go. The twenty-odd pages written
 * against the MEWS connector all funnel through utils/proxy.ts or
 * services/mewsApiService.ts; on a native backend those calls are answered
 * in MEWS shape by /api/pms/compat (backend routes/pmsCompatRoutes.ts) so
 * the pages need no change. Keyed on the PROVIDER, deliberately: the MEWS
 * path is the known-good fallback for anything that is not our own PMS —
 * a MEWS backend, an older backend without /api/pms/info, a failed fetch.
 *
 * Its own module (not an extra export of usePmsInfo) so tests that mock
 * `@/composables/usePmsInfo` for the UI branch keep working untouched.
 */
export async function mewsProxyBasePath(): Promise<'/api/mews' | '/api/pms/compat'> {
  const { provider, ready } = usePmsInfo()
  await ready
  return provider.value === 'native' ? '/api/pms/compat' : '/api/mews'
}
